import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { OpenPreInfoFormAction } from './pre-info-form-dialog.action';
import { PaycellService } from '../services/paycell.service';
import UserService from '../../common/services/user/user.service';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';

/* @ngInject */
export default class PreInfoFormDialogController implements ActionHandler {
  private dialogElement;
  private aggreement: string;
  public offerId?: string;
  public paymentType?: string;
  public paymentTypeMessage?: string;

  protected approve: () => void;

  constructor(
    private $sce,
    private $translate,
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private paycellService: PaycellService,
    private userService: UserService,
    private globalSpinner: GlobalSpinnerService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#pre-info-form-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenPreInfoFormAction) {
      this.approve = action.onApprove;
      this.offerId = action.offerId;
      this.paymentType = action.paymentType;
      if (action.paymentType == 'mobile') {
        this.openDialogMobile();
      } else {
        this.openDialog();
      }
    }
  }

  public onClick() {
    this.close();
  }

  private openDialogMobile() {
    this.globalSpinner.start();
    this.userService.getEulaUrl().then(resp => {

      var httpPattern = /(\<a([^>]*?)(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      resp.eulaTextUrl = resp.eulaTextUrl.replace(httpPattern, '$1?openInExternalBrowser=true" target="_blank');
      var mailPattern = /((mailto):[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      resp.eulaTextUrl = resp.eulaTextUrl.replace(mailPattern,'javascript:void(0)');

      this.aggreement = this.$sce.trustAsHtml(resp.eulaTextUrl);
      this.userService.eulaTextUrl = resp.eulaTextUrl;
      this.dialogElement.open();
    }).catch(error => {
      console.log('eulaModel not found');
    }).finally(() => this.globalSpinner.stop());
  }

  private openDialog() {
    this.paycellService
      .getContractByKey('pre_info_contract', this.offerId)
      .then(contract => {
        if (this.paymentType) {
          const paymentMesssage = 'payment.' + this.paymentType + '.message';
          this.$translate(paymentMesssage).then(value => {
            contract = contract.replace('{{paymentType}}', value);
          }).finally(() => {
            this.aggreement = this.$sce.trustAsHtml(contract);
            this.dialogElement.open();
          });
        } else {
          this.aggreement = this.$sce.trustAsHtml(contract);
          this.dialogElement.open();
        }
      });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onApprove() {
    this.close();
    this.approve();
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/pre-info-form-dialog/pre-info-form-dialog.controller.ts